export function parseStructuralSchemeLauncherEnabled(value: string | undefined): boolean {
  return ['true', '1', 'on'].includes(value?.trim().toLowerCase() ?? '');
}

export const STRUCTURAL_SCHEME_LAUNCHER_ENV =
  'VITE_STRUCTURAL_SCHEME_LAUNCHER_ENABLED' as const;

export const structuralSchemeConfig = {
  launcherEnabled: parseStructuralSchemeLauncherEnabled(
    import.meta.env.VITE_STRUCTURAL_SCHEME_LAUNCHER_ENABLED,
  ),
} as const;
